import React, { useState } from 'react'

import Map from './map'

type OfferMapProps = {
  locations: {
    latitude: number
    longitude: number
    postalCode: string
    street: string
    city: string
  }[]
  apiKey?: string | null
  focusedAddress?: React.Dispatch<React.SetStateAction<{
    street: string;
    city: string;
    postalCode: string;
  } | null>>
  height?: number
}

const MapWithPlaceholder: React.FC<OfferMapProps> = ({
  locations,
  apiKey = undefined,
  focusedAddress = undefined,
  height = 396,
}) => {
  const [openMap, setOpenMap] = useState(false)

  return openMap || focusedAddress ? (
    <Map
      locations={locations}
      apiKey={apiKey ?? ''}
      focusedAddress={focusedAddress}
      height={height}
    />
  ) : (
    <div className="relative h-full rounded-xl">
      <img
        className="object-cover w-full h-full opacity-50 rounded-xl"
        src="/map-placeholder.webp"
        alt="Placeholder par default de carte"
      />
      <button
        type="button"
        onClick={() => setOpenMap(true)}
        className="absolute inset-x-0 inset-y-0 w-full h-full rounded-xl hover:underline"
      >
        Cliquez pour voir la carte
      </button>
    </div>
  )
}

export default MapWithPlaceholder
